import { createFileRoute } from "@tanstack/react-router";
import Trust from "../components/tk/pages/Trust";

const title = "Trust and security | thatKorner";
const description = "Where thatKorner stands on ISO 27001, SOC 2, data residency and AI safeguards, stated plainly: what is in place, what is in progress and when each item is due.";

export const Route = createFileRoute("/trust")({
  head: () => ({
    meta: [
      { title },
      { name: "description", content: description },
      { property: "og:title", content: title },
      { property: "og:description", content: description },
      { property: "og:type", content: "website" },
      { property: "og:url", content: "https://www.thatkorner.com/trust" },
      { name: "twitter:card", content: "summary_large_image" },
    ],
    links: [{ rel: "canonical", href: "https://www.thatkorner.com/trust" }],
  }),
  component: Trust,
});
